import { render, staticRenderFns } from "./FileMimeType.vue?vue&type=template&id=2312566e&scoped=true&"
import script from "./FileMimeType.vue?vue&type=script&lang=js&"
export * from "./FileMimeType.vue?vue&type=script&lang=js&"
import style0 from "./FileMimeType.vue?vue&type=style&index=0&id=2312566e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312566e",
  null
  
)

export default component.exports